<!--
 * @Author: baiwei
 * @Date: 2020-04-02 16:35:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-15 10:30:42
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div class="module">
        <helpInfo :helpData='helpData'>
            <RadioGroup v-model="showType"
                        slot="slotR"
                        type="button"
                        @on-change="typeChange">
                <!-- @on-change="radioChange" -->
                <Radio label="table">
                    <!-- <Tooltip :content="$t('表格')" theme="light"> -->
                    <i class="icon-common icon-all"></i>
                    <!-- </Tooltip> -->
                </Radio>
                <Radio label="level">
                    <!-- <Tooltip :content="$t('层级结构')" theme="light"> -->
                    <i class="icon-common icon-card-o"></i>
                    <!-- </Tooltip> -->
                </Radio>
            </RadioGroup>
        </helpInfo>
        <div class="module-container"
             :class="showType==='level' && 'usergroup-pack'">
            <rcTable ref="rcTable"
                     v-if="showType==='table'"
                     :tableAttr="tableAttr"
                     @onSelectChange="selectedChange">
                <div slot="tootipL">
                    <Button @click="refresh">
                        <i class="icon-refresh-o-2"></i>
                    </Button>
                    <Button type="primary"
                            :disabled="!hasPermission('CH0204')"
                            @click="userGroupForm">
                        <i class="icon-plus-o-1"></i>{{$t('创建')}}
                    </Button>
                </div>
            </rcTable>
            <div v-else>
                <div>
                    <Button type="primary"
                            :disabled="!hasPermission('CH0204')"
                            @click="userGroupForm">
                        <i class="icon-plus-o-1"></i>{{$t('创建')}}
                    </Button>
                </div>
                <div class="level-pack">
                    <!-- <Tree :data="userGroupData" :render="userGroupRender"></Tree> -->
                    <ul :class="userGroupData.length===1 && 'only'">
                        <li v-for="(ug, i) in userGroupData"
                            :key="`ug${i}`">
                            <div class="level-item">
                                <div>
                                    <i class="icon-default-avatar-o"></i>
                                    <span>{{$t(ug.groupName)}}({{ug.userNum}})</span>
                                </div>
                                <div class="operate-pack none">
                                    <i class="icon-rights-profile-o"
                                       v-if="hasPermission('CH0205')"
                                       @click="condifureUser(ug.groupSid)"
                                       :title="$t('配置用户')"></i>
                                    <i class="icon-site-o"
                                       v-if="hasPermission('CH0206') && !ug.sysDefault"
                                       @click="configureUserGroupPolices(ug.groupSid)"
                                       :title="$t('配置权限')"></i>
                                    <i class="icon-delete-o"
                                       v-if="hasPermission('CH0203')&& !ug.sysDefault"
                                       @click="deleteUserGroup(ug.groupSid)"
                                       :title="$t('删除')"></i>
                                </div>
                            </div>
                            <div v-if="ug.children && ug.children.length"
                                 class="child-pack">
                                <ul>
                                    <li v-for="(child, ii) in ug.children"
                                        :key="`child${ii}`">
                                        <Poptip trigger="hover"
                                                width="100"
                                                style="min-width: auto">
                                            <div>
                                                <i class="icon-default-avatar-o"></i>
                                                <span>{{child.groupName}}</span>
                                            </div>
                                            <div slot="content"
                                                 class="operate-pack"
                                                 style="display:flex;justify-content: space-between; ">
                                                <i class="icon-rights-profile-o"
                                                   v-if="hasPermission('CH0205')"
                                                   @click="condifureUser(child.groupSid)"
                                                   :title="$t('配置用户')"></i>
                                                <i class="icon-site-o"
                                                   v-if="hasPermission('CH0206')"
                                                   @click="configureUserGroupPolices(child.groupSid)"
                                                   :title="$t('配置权限')"></i>
                                                <i class="icon-delete-o"
                                                   v-if="hasPermission('CH0203')"
                                                   @click="deleteUserGroup(child.groupSid)"
                                                   :title="$t('删除')"></i>
                                            </div>
                                        </Poptip>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <userGroupForm ref="userGroupForm"
                       @refresh="refresh"></userGroupForm>
        <configureUser ref="configureUser"
                       @refresh="refresh"></configureUser>
        <configureUserGroupPolices ref="configureUserGroupPolices"></configureUserGroupPolices>
    </div>
</template>
<script>
import helpInfo from '@c/basic/helpinfo'
import rcTable from '@c/basic/rcTable'
import userGroupForm from './components/usergroupform'
import configureUser from '../components/configureuser'
import configureUserGroupPolices from '../components/configureusergrouppolices'
import API from '@/service/api.js'
export default {
    name: 'usergroup',
    components: {
        helpInfo,
        rcTable,
        userGroupForm,
        configureUser,
        configureUserGroupPolices
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('用户组')
            },
            showType: 'table',
            selected: [], // 所选用户
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.ACCESS_USERGROUPS, false),
                    params: {
                        includeDefaultGroup: true
                    }
                },
                searchShow: true,
                columnsChooseShow: true,
                // isMultiSelect: true,
                referenceVal: 1200,
                searchColumns: [
                    {
                        key: 'groupNameLike',
                        title: this.$t('用户组名称'),
                        searchDefaultValue: ''
                    }
                ],
                columns: [
                    {
                        title: this.$t('用户组名称'),
                        key: 'groupName',
                        columnShow: true,
                        columnsChoosed: true,
                        resizable: true,
                        className: 'ellipsis',
                        width: 120,
                        disabledSearch: true,
                        render: (h, params) => h(this.hasPermission('CH0201') ? 'a' : 'span', {
                            attrs: { title: params.row.groupName },
                            on: {
                                click: () => {
                                    this.$router.push({
                                        name: 'usergroupdetail',
                                        params: {
                                            id: params.row.groupSid
                                        }
                                    })
                                }
                            }
                        }, this.$t(params.row.groupName))
                    },
                    {
                        title: this.$t('上级组'),
                        key: 'parentName',
                        columnShow: true,
                        columnsChoosed: true,
                        resizable: true,
                        className: 'ellipsis',
                        width: 120,
                        disabledSearch: true,
                        render: (h, params) => h('span', { attrs: { title: params.row.parentName } }, this.$t(params.row.parentName))
                    },
                    {
                        title: this.$t('用户数量'),
                        key: 'userNum',
                        columnShow: true,
                        columnsChoosed: true,
                        resizable: true,
                        className: 'ellipsis',
                        width: 100,
                        disabledSearch: true,
                        render: (h, params) => h('span', { attrs: { title: params.row.userNum } }, params.row.userNum)
                    },
                    {
                        title: this.$t('描述'),
                        key: 'description',
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        disabledSearch: true,
                        render: (h, params) => h('span', { attrs: { title: params.row.description } }, this.$t(params.row.description))
                    },
                    {
                        title: this.$t('创建时间'),
                        key: 'createdDt',
                        // columnShow: true,
                        // columnsChoosed: true,
                        resizable: true,
                        className: 'ellipsis',
                        minWidth: 150,
                        disabledSearch: true,
                        render: (h, params) => h('span', { attrs: { title: params.row.createdDt } }, params.row.createdDt)
                    },
                    {
                        title: this.$t('操作'),
                        // align: 'center',
                        resizable: false,
                        fixed: 'right',
                        width: 180,
                        render: (h, params) => {
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, [
                                h('a', {
                                    class: { 'disabled-per': !this.hasPermission('CH0205') },
                                    on: { click: () => this.hasPermission('CH0205') && this.hasPermission('CH0205') && this.condifureUser(params.row.groupSid) }
                                }, this.$t('配置用户')),
                                h('a', {
                                    class: { 'disabled-per': params.row.sysDefault || !this.hasPermission('CH0206') },
                                    on: { click: () => !params.row.sysDefault && this.hasPermission('CH0206') && this.configureUserGroupPolices(params.row.groupSid) }
                                }, this.$t('配置权限')),
                                h('a', {
                                    class: { 'disabled-per': params.row.sysDefault || !this.hasPermission('CH0203') },
                                    on: { click: () => !params.row.sysDefault && this.hasPermission('CH0203') && this.deleteUserGroup(params.row.groupSid) }
                                }, this.$t('删除'))
                            ])
                        }
                    }
                ]
            },
            userGroupData: []
        }
    },
    created () {
        this.typeChange()
    },
    methods: {
        // 刷新
        refresh () {
            this.showType === 'table' ? this.$refs.rcTable.refreshTable() : this.typeChange()
        },
        // 表格勾选
        selectedChange (selection) {
            this.selected = selection
        },
        typeChange () {
            if (this.showType === 'level') {
                this.axios.get(this.urlFormat(API.ACCESS_USERGROUPS, false), { params: { type: 'tree', includeDefaultGroup: true } }).then(res => {
                    this.userGroupData = res
                })
            }
        },
        userGroupForm () {
            this.$refs.userGroupForm.open()
        },
        condifureUser (groupSid) {
            this.$refs.configureUser.open(groupSid)
        },
        configureUserGroupPolices (groupSid) {
            this.$refs.configureUserGroupPolices.open(groupSid)
        },
        deleteUserGroup (id) {
            this.$Modal.confirm({
                title: this.$t('确定要删除该用户组吗？'),
                content: this.$t('删除无法恢复，请谨慎操作。'),
                okText: this.$t('确定'),
                cancelText: this.$t('取消'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.ACCESS_USERGROUP, false, [id])).then(res => {
                        this.refresh()
                    })
                }
            })
        },
        userGroupRender (h, { root, node, data }) {
            return h('div', {
                class: ['leaf-pack']
            }, [
                h('span', data.title),
                h('div', {
                    class: ['operate']
                }, [
                    h('a', {
                        class: ['icon-plus-o-1-1']
                    }),
                    h('a', {
                        class: ['icon-delete-o-1']
                    })
                ])
            ])
        }
    }
}
</script>

<style lang="less">
.usergroup-pack {
    // background: url(./bg.png) no-repeat;
    background-color: #f5f6f7;
    padding-bottom: 250px !important;
    .level-pack {
        padding: 65px 38px;
        & > ul {
            border: 1px solid #1f68b3;
            border-width: 1px 0 1px 1px;
            padding-left: 20px;
            & > li {
                padding: 8px 10px;
                background-color: #f5f6f7;
                position: relative;
                &:before {
                    content: '';
                    display: inline-block;
                    width: 20px;
                    border-top: 1px solid #1f68b3;
                    position: absolute;
                    left: -21px;
                    top: 49px;
                }
                &:first-child {
                    margin-top: -44px;
                    &:before {
                        display: none;
                    }
                }
                &:last-child {
                    height: 108px;
                    margin-bottom: -44px;
                    &:before {
                        display: none;
                    }
                    .child-pack {
                        margin-bottom: -88px;
                        height: 64px;
                    }
                }
            }
            &.only {
                border: 0;
            }
        }
        .level-item {
            height: 88px;
            padding: 28px 15px 28px 43px;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            align-items: center;
            i {
                font-size: 32px;
                margin-right: 10px;
                color: #808080;
                vertical-align: middle;
            }
            &:hover {
                .operate-pack {
                    display: block;
                }
            }
        }
        .operate-pack {
            &.none {
                display: none;
            }
            i {
                font-size: 14px;
                color: #1f68b3;
                cursor: pointer;
            }
            .icon-delete-o {
                color: #ff6a01;
            }
        }
        .child-pack {
            margin-left: 30px;
            margin-bottom: 54px;
            padding-top: 8px;
            border: 1px solid #ccc;
            border-width: 0 0 1px 1px;
            ul {
                min-height: 108px;
                margin: 2px 0 -54px 30px;
                padding: 10px 40px;
                background-color: #fff;
                border-left: 10px solid #f5f6f7;
                display: flex;
                flex-wrap: wrap;
                li {
                    width: 16.66%;
                    min-width: 120px;
                    text-align: center;
                    padding: 10px 0;
                    i.icon-default-avatar-o {
                        display: inline-block;
                        width: 42px;
                        height: 42px;
                        line-height: 42px;
                        text-align: center;
                        border-radius: 50%;
                        color: #fff;
                        font-size: 20px;
                        background-color: #1f68b3;
                    }
                    span {
                        display: block;
                        font-size: 12px;
                        margin-top: 10px;
                    }
                }
            }
        }
    }
}
</style>
